import Skills from "../components/Skills";
import Footer from "../components/Footer";
import Header from "../components/Header";

function SkillsPage () {
  return (
    <>
      <Header />
      <Skills />
      <Footer />
    </>
  )
}

export default SkillsPage;
